/// <amd-module name="Mention/Autocomplete/Components/AutocompleteFooter" />
import * as React from "react";
import { useEffect } from "react";
import { announce } from "VSS/Core/Util/Accessibility";

export interface IAutocompleteFooterProps {
    statusText: string;
}

export const AutocompleteFooter: React.StatelessComponent<IAutocompleteFooterProps> = (props: IAutocompleteFooterProps): JSX.Element => {
    const { statusText } = props;

    useEffect(() => {
        announce(statusText, true, 200);
    }, [statusText]);

    return (
        <div className="autocomplete-footer-footer">
            <div className="autocomplete-footer-status">
                <span className="autocomplete-footer-status-text">{statusText}</span>
            </div>
        </div>
    );
};
